/* eslint-disable no-unused-vars */
import { get } from "../config";

export function GetMouCompany() {
  return get({ url: `/api/aunjai/MOUCompany` });
}
